import { Table } from "antd";
import moment from "moment";
import React from "react";
import { totalTimeOrScore } from "../../helper/scoreCounter";
import { objectValidation } from "../../helper/validation";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import { LaunchTestContext } from "../../store/launchTestStore";
import "./testSummary.scss";

export default function DefaultTestSum({ questions }) {
  const { launchTestC, dispatchLaunchTest } = LaunchTestContext();
  const { helperC, dispatchHelper } = HelperContext();
  const { launchTestData, loader, err } = launchTestC;
  const { answerC, dispatchAnswer } = AnswerContext();
  const isDemoTest = helperC.testType === "DEMO";
  const isCalibrationTest = helperC.testType === "CALIBRATION";
  console.log("questions", questions);
  const launchTestQue =
    !isDemoTest &&
    !isCalibrationTest &&
    objectValidation(launchTestData) &&
    launchTestData.data[0];

  let levelId = JSON.parse(localStorage.getItem("gradeId"));
  levelId =
    levelId === "2"
      ? "L1"
      : levelId === "5"
      ? "L2"
      : levelId === "8"
      ? "L3"
      : levelId === "12"
      ? "L4"
      : "L1";

  const getAns = (answer) => {
    console.log("answer.timeSpendSound", answer.timeSpendSound);

    if (!!answer.timeSpendSound && !!answer.timeSpendSound) {
      return {
        ans: `${Math.floor(answer.averageTimeSpend)} ms`,
        score: answer.totalScore,
      };
    }
    // Special Case for simple React and choice Reaction
    else if (answer.answer === "RT") {
      return {
        ans: answer.que_time ? `${Math.floor(answer.que_time)} ms` : 0,
        score: answer.que_score ? `${Math.floor(answer.que_score)}` : 0,
      };
    } else {
      return {
        ans: !!answer.answer ? answer.answer : "NA",
        score: !!answer.que_score
          ? parseFloat(answer.que_score.toFixed(2).toString())
          : 0,
      };
    }
  };

  const dataSource = () =>
    answerC.answers.map((answer, index) => {
      console.log("answeranswer", answer);
      return {
        key: index,
        que: index + 1,
        answer: getAns(answer).ans,
        score:
          Math.sign(parseInt(getAns(answer).score)) === -1
            ? 0
            : getAns(answer).score,
      };
    });

  const columns = [
    {
      title: "Que No.",
      dataIndex: "que",
      key: "que",
      align: "left",
    },
    {
      title: "Answer",
      dataIndex: "answer",
      key: "answer",
      align: "left",
    },
    {
      title: "Score",
      dataIndex: "score",
      key: "score",
      align: "left",
    },
  ];

  return (
    <Table
      tableLayout="fixed"
      dataSource={dataSource()}
      columns={columns}
      pagination={false}
      className="summaryTable"
      scroll={{
        y: 360,
      }}
      title={() => {
        return (
          <div className="summary-header">
            <div className="summary-header-left">
              {isCalibrationTest ? (
                <p>Calibration Test</p>
              ) : (
                <p>
                  {launchTestQue.section_name} | {levelId}
                </p>
              )}
              <p>Test date: {moment().format("DD-MMM-YYYY")} </p>
            </div>
            <div className="summary-header-right">
              <p>{totalTimeOrScore(answerC.answers, questions).player_score}</p>
              <p>score</p>
            </div>
          </div>
        );
      }}
    />
  );
}
